<template>
    <el-menu :default-active="$route.path" :router="true" :collapse="collapse"
             text-color="#fff" background-color="#2f4050">
        <el-menu-item class="sidebar-header" index="/">
            <template v-if="collapse">
                <i class="el-icon-s-home"></i>
                <span slot="title">{{$t("首页")}}</span>
            </template>
            <template v-else>
                <img class="logo" src="../assets/logo_white.png" alt="Logo" height="25">
                <small style="color: #909399">{{$root.user.alias}}</small>
            </template>
        </el-menu-item>
        <template v-for="menu in menus">
            <el-submenu v-if="menu.child.length > 0" :key="menu.id" :index="menu.id + ''">
                <template slot="title">
                    <i :class="menu.icon ? menu.icon : 'el-icon-folder'"></i>
                    <span slot="title">{{getName(menu)}}</span>
                </template>
                <template v-for="sub in menu.child">
                    <el-submenu v-if="sub.child.length > 0" :index="sub.id + ''" :key="sub.id">
                        <template slot="title">
                            <i :class="sub.icon ? sub.icon : 'el-icon-folder'"></i>
                            <span slot="title">{{getName(sub)}}</span>
                        </template>
                        <el-menu-item :index="sub2.path" v-for="sub2 in sub.child" :key="sub2.id">
                            <i :class="sub2.icon ? sub2.icon : 'el-icon-folder'"></i>
                            <span slot="title">{{getName(sub2)}}</span>
                        </el-menu-item>
                    </el-submenu>
                    <el-menu-item v-else :key="sub.id" :index="sub.path">
                        <i :class="sub.icon ? sub.icon : 'el-icon-folder'"></i>
                        <span slot="title">{{getName(sub)}}</span>
                    </el-menu-item>
                </template>
            </el-submenu>
            <el-menu-item v-else :key="menu.id" :index="menu.path">
                <i :class="menu.icon ? menu.icon : 'el-icon-folder'"></i>
                <span slot="title">{{getName(menu)}}</span>
            </el-menu-item>
        </template>
    </el-menu>
</template>

<i18n locale="en" lang="yaml">
    首页: Home
</i18n>

<script>
    export default {
        name: "SideBar",
        props: ["collapse"],
        data() {
            return {
                menus: this.getChildMenus(1)
            }
        },
        methods: {
            getChildMenus(id) {
                let child = [];
                this.$root.menus.forEach(menu => {
                    if (menu['parentId'] === id) {
                        child.push({
                            id: menu['id'],
                            icon: menu['icon'],
                            name: menu['name'],
                            enName: menu['enName'],
                            path: menu['path'],
                            child: this.getChildMenus(menu['id'])
                        });
                    }
                });
                return child;
            },
            getName(menu) {
                if (this.$i18n.locale === "en") {
                    return menu['enName'] || menu['name'];
                } else {
                    return menu['name'];
                }
            }
        }
    }
</script>

<style scoped>
    .el-menu {
        border-right: 0 !important;
    }

    .el-menu:not(.el-menu--collapse) {
        width: 220px;
    }

    .sidebar-header {
        padding: 10px !important;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #909399;
    }

    .sidebar-header:after {
        content: "";
        position: absolute;
        bottom: 0;
        right: 6px;
        height: 1px;
        width: calc(100% - 12px);
        background-color: hsla(0,0%,70.6%,.3);
    }

    .el-menu-item:not(.sidebar-header).is-active {
        border-left: 4px solid #19aa8d;
        background-color: #293846 !important;
        color: #fff;
        font-weight: 600;
    }
</style>
<style>
    .el-submenu__title, .el-menu-item:not(.sidebar-header) {
        height: 46px;
        line-height: 46px;
    }
</style>